import React from 'react';
import Grid from "@material-ui/core/Grid";
import { formatWaitingPeriodEndDate } from '../../utils/waitingPeriodHelpers';

const WaitingPeriodWarnings = ({ warnings, currencyCode }) => {
  if (!warnings || warnings.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={2} style={{ marginTop: '16px' }}>
      <Grid item xs={12}>
        {warnings.map(function(warning, index) {
          if (warning.canClaimDuringWaiting) {
            // FUNERAL/ACCIDENTAL - blue info banner
            return (
              <div
                key={index}
                style={{
                  backgroundColor: '#e3f2fd',
                  border: '1px solid #2196f3',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '12px'
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  color: '#1565c0',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>
                  <span style={{ marginRight: '8px' }}>&#9432;</span>
                  {warning.benefitType} - In waiting period
                </div>
                <div style={{
                  fontSize: '13px',
                  color: '#5d4037',
                  lineHeight: '1.6'
                }}>
                  <div>
                    <strong>Waiting Period Ends:</strong> {formatWaitingPeriodEndDate(warning.waitingPeriodEndDate)}
                  </div>
                  <div style={{ marginTop: '8px' }}>
                    <strong>Benefit Amount:</strong> {currencyCode} {(warning.currentAmount / 100).toLocaleString()}
                  </div>
                </div>
              </div>
            );
          }

          // Other benefits - orange warning banner
          return (
            <div
              key={index}
              style={{
                backgroundColor: '#fff3e0',
                border: '1px solid #ff9800',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '12px'
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
                color: '#e65100',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
                <span style={{ marginRight: '8px' }}>&#9888;</span>
                {warning.benefitType} - In waiting period
              </div>
              <div style={{
                fontSize: '13px',
                color: '#5d4037',
                lineHeight: '1.6'
              }}>
                <div>
                  This benefit is still in its waiting period.
                </div>
                <div style={{ marginTop: '8px' }}>
                  <strong>Waiting Period Ends:</strong> {formatWaitingPeriodEndDate(warning.waitingPeriodEndDate)}
                </div>
                <div style={{ marginTop: '8px' }}>
                  <strong>Benefit Amount:</strong> {currencyCode} {(warning.currentAmount / 100).toLocaleString()}
                </div>
              </div>
            </div>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default WaitingPeriodWarnings;
